'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { ExerciseSession } from '@openclassrooms/sdk-web';
import type { QuizInfo } from '../_fetchData';

type ExerciseContextValue = {
  exerciseId: number;
  canEditCourse: boolean;
  initialExerciseSession?: ExerciseSession | null;
  initialQuizInfo?: QuizInfo | null;
};

const ExerciseContext = createContext<ExerciseContextValue | undefined>(undefined);

type Props = {
  children: ReactNode;
  value: ExerciseContextValue;
};

export const ExerciseProvider = ({ children, value }: Props) => (
  <ExerciseContext.Provider value={value}>{children}</ExerciseContext.Provider>
);

export const useExerciseContext = () => {
  const context = useContext(ExerciseContext);
  if (!context) {
    throw new Error('useExerciseContext must be used within an ExerciseProvider');
  }
  return context;
};
